import { useMutation, useQueryClient } from 'react-query';

import { Category } from '../../../types/Category';
import Api from '../../api/api';

export const deleteSubCategory = async (subCategoryId: string) => {
  const [response, bodyOrError] = await Api.delete(`sub-categories/${subCategoryId}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useDeleteSubCategory = () => {
  const queryClient = useQueryClient();

  return useMutation<Category, Error, string>('deleteSubCategory', deleteSubCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries('getSubCategoriesByPage');
    },
  });
};
